
import PapaParse from 'papaparse';
export const getYears = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 1900;
  return Array.from(
    { length: currentYear - startYear + 1 },
    (item, index) => startYear + index,
  ).reverse();
};

export const getMonths = () => {
  return Array.from({ length: 12 }, (item, index) => ({
    name: new Date(0, index).toLocaleString('default', { month: 'long' }),
    number: index + 1,
  }));
};

export const csvFileToArray = (dataString) => {
  const result = PapaParse.parse(dataString, {
    skipEmptyLines: true,
    header: true,
  }).data;
  return result;
};
